import { render, staticRenderFns } from "./ModalEditAcademy.vue?vue&type=template&id=08ab11f7&scoped=true&lang=pug&"
import script from "./ModalEditAcademy.vue?vue&type=script&lang=ts&"
export * from "./ModalEditAcademy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ab11f7",
  null
  
)

export default component.exports